import app from 'app';

import form from './product/form';
import product from './product/main';
import lightbox from './product/lightbox';
import media from './product/media';
import recommendations from './product/recommendations';

app.add({
  product,
  lightbox,
  'product-form': form,
  'product-media': media,
  'product-recommendations': recommendations,
});

app.mount();
